import { type FunctionalComponent, h } from '@stencil/core';
import type { ConversationalSearchProductHierarchy } from '../../../conversational-search-types/conversational-search-types.type';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import { ConversationalSearchMessagesSuggestionsCard } from '../suggestions/suggestions-card/suggestions-card';

export interface IConversationalSearchProductHierarchySuggestions {
  data: ConversationalSearchProductHierarchy['subLevels']
  labelProvider: labelProviderInterface;
  query: string;
  optionsAmount: number;
  language: string;
}

export const ConversationalSearchProductHierarchySuggestions: FunctionalComponent<
  IConversationalSearchProductHierarchySuggestions
> = (props) => {
    const isMultipleSuggestion = props.optionsAmount > 1;

    return (
      <section class={{'conversational-search-product-hierarchy-suggestions': isMultipleSuggestion}}>
        {props.data?.map((suggestion, index) => (
          <ConversationalSearchMessagesSuggestionsCard
            data={suggestion}
            query={props.query}
            labelProvider={(e, f) => props.labelProvider(e, f)}
            isMultipleSuggestions={isMultipleSuggestion}
            index={index}
            language={props.language}
          />
        ))}
      </section>
    );
};
